import { render } from "./RenameGroup.vue?vue&type=template&id=0593c770"
import script from "./RenameGroup.vue?vue&type=script&lang=js"
export * from "./RenameGroup.vue?vue&type=script&lang=js"
script.render = render

export default script